import { useSyncExternalStore, useCallback } from 'react';
import { ApiView } from '../core/ApiView';

export function useApiView<V extends ApiView>(view: V): V {
  const subscriber = useCallback(
    (onStoreChange: () => void) => {
      view.subscribe(onStoreChange);
      return () => view.destroy();
    },
    [view]
  );

  useSyncExternalStore(subscriber, () => view.state);

  return view;
}
